import { getUsers } from '../api/USERS/users';
import { useQuery } from '@tanstack/react-query';

export const useUsers = () => {
    return useQuery({
        queryKey: ['users'],
        queryFn: getUsers,
        staleTime: 4 * 60 * 60 * 1000,
        refetchOnWindowFocus: false,
      });
};

